import { generateBFFUrl } from '@/configs/apiEndPoints';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import axiosInstance from '../axiosConfig';
import dlv from 'dlv';

export const getPromoOffer = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl('/cms/d2c/config/offer-web-config'));
    return dlv(response, 'data.data.attributes.data', {});
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
